// import ExcelJS from "exceljs";

// const statusArray = ["VISA STAMPED"];

// export default function visaDetailsTemplate(candidateData) {
//   const candidatesArray = candidateData?.candidates?.map((data) => data?.name);
//   const nationalityArray = candidateData?.nationality?.map(
//     (data) => data?.name
//   );
//   const jobPositionArray = candidateData?.job_possition?.map(
//     (data) => data?.name
//   );
//   const visaProfessionArray = candidateData?.visa_profession?.map(
//     (data) => data?.name
//   );

//   const professionSheet = workbook.addWorksheet("Dropdowns");
//   visaProfessionArray.forEach((value, index) => {
//     professionSheet.getCell(`A${index + 1}`).value = value;
//   });
//   professionSheet.state = "veryHidden";

//   console.log(visaProfessionArray, "candidate and visa profession");
//   const sectorArray = candidateData?.sector?.map((data) => data?.name);

//   const headings = [
//     { title: "passport_number", type: "text", values: "AKS1" },
//     // {
//     //   title: "actual_profession",
//     //   type: "dropdown",
//     //   values: [`dropdown!B1:B${jobPositionArray.length}`],
//     //   initialValue: jobPositionArray[0],
//     // },

//     { title: "visa_block_number", type: "text", values: "ALPHA NUMERIC" },
//     {
//       title: "visa_profession",
//       type: "dropdown",
//       formulae: ["Dropdowns!$A$1:$A$200"],
//       // initialValue: visaProfessionArray[0],
//     },
//     { title: "visa_reference_number", type: "text", values: "ALPHA NUMERIC" },
//     { title: "visa_stamping_date", type: "text", values: "03-10-1997" },
//     {
//       title: "status",
//       type: "dropdown",
//       values: [`"${statusArray.toString()}"`],
//       initialValue: statusArray[0],
//     },
//   ];

//   const workbook = new ExcelJS.Workbook();
//   const sheet = workbook.addWorksheet("Sheet1");
//   const dropdownWorkSheet = workbook.addWorksheet("dropdown", {
//     state: "hidden",
//   });
//   for (let i = 0; i < visaProfessionArray?.length; i++) {
//     const row = dropdownWorkSheet.getRow(i + 1);
//     row.getCell("A").value = visaProfessionArray[i];
//   }
//   for (let i = 0; i < jobPositionArray?.length; i++) {
//     const row = dropdownWorkSheet.getRow(i + 1);
//     row.getCell("B").value = jobPositionArray[i];
//   }

//   const titleRowStyle = {
//     alignment: { horizontal: "center", vertical: "middle" },
//     fill: {
//       type: "pattern",
//       pattern: "solid",
//       fgColor: { argb: "FFFFFF00" }, // Yellow color in ARGB format
//     },
//     border: {
//       top: { style: "thin", color: { argb: "FF000000" } }, // Black color
//       left: { style: "thin", color: { argb: "FF000000" } },
//       bottom: { style: "thin", color: { argb: "FF000000" } },
//       right: { style: "thin", color: { argb: "FF000000" } },
//     },
//   };

//   const titleRow = sheet.getRow(1);
//   titleRow.height = 30;
//   titleRow.getCell(1).value = "sno.";
//   titleRow.getCell(1).style = titleRowStyle;

//   for (let i = 0; i < headings.length; i++) {
//     titleRow.getCell(i + 2).style = titleRowStyle;
//     titleRow.getCell(i + 2).value = headings[i].title;

//     const column = sheet.getColumn(i + 2);
//     column.width = 24;
//   }

//   const row = sheet.getRow(2); // 2nd row
//   row.getCell(1).value = 1;
//   for (let i = 0; i < headings.length; i++) {
//     if (headings[i].type == "dropdown") {
//       row.getCell(i + 2).value = headings[i].initialValue;
//       row.getCell(i + 2).dataValidation = {
//         type: "list",
//         formulae: headings[i].values,
//         allowBlank: true,
//         operator: "equal",
//         promptTitle: "Select an option",
//         prompt: headings[i]?.title,
//       };
//     } else if (headings[i].type == "date") {
//       row.getCell(i + 2).value = headings[i].values;
//       row.getCell(i + 2).dataValidation = {
//         type: "date",
//         // allowBlank: true,
//         showErrorMessage: true,
//         errorStyle: "error",
//         formulae: [new Date()],
//         error: "It should be a date.",
//       };
//       row.getCell(i + 2).numFmt = "dd/mm/yyyy";
//     } else if (headings[i].type == "number") {
//       row.getCell(i + 2).value = headings[i].values;
//       row.getCell(i + 2).dataValidation = {
//         type: "whole",
//         operator: "greaterThanOrEqual",
//         showErrorMessage: true,
//         formulae: [0],
//         errorStyle: "error",
//         error: "The value must be a number",
//       };
//     } else {
//       row.getCell(i + 2).value = headings[i].values || "-";
//     }
//   }

//   // Generate the Excel file and initiate download
//   workbook.xlsx.writeBuffer().then((buffer) => {
//     const blob = new Blob([buffer], {
//       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//     });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = "Template - VISA Details.xlsx";
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     +URL.revokeObjectURL(url);
//   });
// }

import ExcelJS from "exceljs";

const statusArray = ["VISA STAMPED"];

export default function visaDetailsTemplate(candidateData) {
  const ExcelJS = require("exceljs");

  const candidatesArray = candidateData?.candidates?.map((data) => data?.name);
  const nationalityArray = candidateData?.nationality?.map(
    (data) => data?.name
  );
  const jobPositionArray = candidateData?.job_possition?.map(
    (data) => data?.name
  );
  const visaProfessionArray = candidateData?.visa_profession?.map(
    (data) => data?.name
  );
  const sectorArray = candidateData?.sector?.map((data) => data?.name);

  // const statusArray = ["Active", "Inactive"]; // Required for status dropdown

  const statusArray = ["VISA STAMPED"];

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Sheet1");

  // Create hidden dropdown sheet for visa_profession
  const professionSheet = workbook.addWorksheet("Dropdowns");
  visaProfessionArray?.forEach((value, index) => {
    professionSheet.getCell(`A${index + 1}`).value = value;
  });
  professionSheet.state = "veryHidden";

  const headings = [
    { title: "passport_number", type: "text" },
    { title: "visa_block_number", type: "text" },
    {
      title: "visa_profession",
      type: "dropdown",
      formulae: ["Dropdowns!$A$1:$A$200"],
    },
    { title: "visa_reference_number", type: "text" },
    { title: "visa_stamping_date", type: "text" },
    {
      title: "status",
      type: "dropdown",
      values: [`"${statusArray.join(",")}"`],
    },
  ];

  const titleRowStyle = {
    alignment: { horizontal: "center", vertical: "middle" },
    fill: {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFFFF00" }, // Yellow
    },
    border: {
      top: { style: "thin", color: { argb: "FF000000" } },
      left: { style: "thin", color: { argb: "FF000000" } },
      bottom: { style: "thin", color: { argb: "FF000000" } },
      right: { style: "thin", color: { argb: "FF000000" } },
    },
  };

  // Header Row
  const titleRow = sheet.getRow(1);
  titleRow.height = 30;
  titleRow.getCell(1).value = "sno.";
  titleRow.getCell(1).style = titleRowStyle;

  headings.forEach((heading, i) => {
    const cell = titleRow.getCell(i + 2);
    cell.value = heading.title;
    cell.style = titleRowStyle;
    sheet.getColumn(i + 2).width = 24;
  });

  const maxRows = 500; // Adjust this if needed

  for (let rowIndex = 2; rowIndex <= maxRows + 1; rowIndex++) {
    const row = sheet.getRow(rowIndex);
    // row.getCell(1).value = rowIndex - 1; // Set serial number

    headings.forEach((heading, i) => {
      const cell = row.getCell(i + 2);

      if (heading.type === "dropdown") {
        cell.dataValidation = {
          type: "list",
          formulae: heading.formulae || heading.values,
          allowBlank: true,
          promptTitle: "Select an option",
          prompt: heading.title,
        };
      }
    });
  }

  // Export the Excel file
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Template - VISA Details.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  });
}
